import {
    Component,
    OnInit,
    Input
} from '@angular/core';

import { default as RESOURCES } from '../resource';

@Component({
    selector: 'app-transaction-resource',
    templateUrl: './transaction-resource.component.pug',
    styleUrls: ['./transaction-resource.component.less']
})
export class TransactionResourceComponent implements OnInit {

    @Input() resourceType;
    @Input() amount;
    @Input() price;
    @Input() shard;

    public resource;

    constructor() { }

    ngOnInit() {
        this.resource = RESOURCES[this.resourceType];
    }

}
